<template>
  <div>
    <portal to="page-top-title">Edit Category #{{ id }}</portal>
    <portal to="page-top-right">
      <btn :route="{ name: 'templates-categories-single', params: { id: id } }" icon="fa-eye" text>Back to Category</btn>
    </portal>

    <box-form action="edit" data-prop="formData" redirect="templates-categories-list" :url="`/templates/categories/${id}`" :loaded="loaded" loader>
      <template slot="content">
        <row>
          <column-input>
            <form-group-input name="name" :model="formData.name" :min="3" required/>
          </column-input>
          <column-input>
            <form-group-select name="group_id" title="Group" :model="formData.group_id"
                               :options="groups" :disabled="!groups.length" required/>
          </column-input>
          <column-input :md="2">
            <form-group-check name="active" :model="formData.active"/>
          </column-input>
        </row>
      </template>
    </box-form>
  </div>
</template>

<script>
import BoxForm from '@/views/components/data/BoxForm'
import Btn from '@/views/components/simple/Btn'
import FormGroupCheck from '@/views/components/form/FormGroupCheck'
import FormGroupInput from '@/views/components/form/FormGroupInput'
import FormGroupSelect from '@/views/components/form/FormGroupSelect'
import Form from '@/modules/utils/Form'

export default {
  name: 'TemplatesCategoriesEdit',
  metaInfo () {
    return { title: `Templates | Category #${this.id} | Edit` }
  },
  components: {
    BoxForm,
    Btn,
    FormGroupCheck,
    FormGroupInput,
    FormGroupSelect
  },
  computed: {
    id () { return this.$route.params.id }
  },
  data () {
    return {
      loaded: false,
      groups: [],
      formData: {
        name: Form.types.input(),
        group_id: Form.types.select(),
        active: Form.types.boolean()
      }
    }
  },
  created () {
    this.loadEntity()
    this.loadGroups()
  },
  methods: {
    loadEntity () {
      this.$http
        .get(`/templates/categories/${this.id}`)
        .then((res) => {
          const { data: { data } } = res

          this.formData.name.value = data.name
          this.formData.active.value = data.active
          this.formData.group_id.value = { id: data.group.id, name: data.group.name }

          this.loaded = true
        })
    },
    loadGroups () {
      this.$http
        .get('/category-groups', { params: { no_pages: 1 } })
        .then((res) => {
          const { data: { data } } = res

          this.groups = data.map((group) => { return { id: group.id, name: group.name } })
        })
    }
  }
}
</script>
